const styles = {
  deleteButton: {
    marginRight: 'auto !important'
  },
  footer: {
    justifyContent: 'space-between'
  }
}

export default styles
